import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import messages from './messages';
import Button from '../button/index';
import { DARK } from '../button/variants';
import { Warning, Tick } from '../../helpers/icon-dictionary';
import Modal from '../../components/modal/index';
import BulkPasswordChange from '../bulk-password-change/index';
import StudentUnassign from '../../components/student-unassign/index';
import ConfirmationMessage from '../../components/confirmation-message/index';
import UserDelete from '../../components/user-delete/index';
import SignInCardsFormats from '../../components/sign-in-cards-formats';

const StudentFooter = ({
    noOfSelectedStudents = 0,
    handleOnStudentUnassign,
    handleOnStudentBulkPasswordChange,
    handleOnDownloadSignInCards,
    showModal,
    handleOnCloseModal,
    handleOnUnassignConfirm,
    isUserOperationModalOpen,
    handleOnBulkPasswordChangeConfirm,
    handleOnChangeBulkPasswordSetValue,
    isLoading,
    studentsOperationSuccessConfirmation,
    isSignInCardDownloaded,
    handleOnStudentDeleteConfirmation,
    handleOnDeleteStudent,
    operationType,
    bulkPasswordValue,
    intl,
    handleOnDeleteConfirmation,
    downloadStudentsSignInCards
}) => {
    let confirmation = <div />;
    switch (operationType) {
    case 'downloadSignInCard':
        confirmation = isUserOperationModalOpen
            ? (
                <SignInCardsFormats
                    handleOnCancel={handleOnCloseModal}
                    handleOnDownloadSignInCards={handleOnDownloadSignInCards}
                    isSignInCardDownloaded={isSignInCardDownloaded} />)
            : <div />;
        break;
    case 'unassignUser':
        confirmation = isUserOperationModalOpen
            ? (
                <StudentUnassign
                    handleOnCancel={handleOnCloseModal}
                    handleOnOk={handleOnUnassignConfirm}
                    icon={Warning}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.unassignStudent, { s: noOfSelectedStudents > 1 ? 's' : '' })}>
                    <div>{intl.formatMessage(messages.selectedStudentWill, { s: noOfSelectedStudents > 1 ? 's' : '' })}
                        <span className={css.highlight}>{` ${intl.formatMessage(messages.unassignedFooter)} `}</span>
                        {intl.formatMessage(messages.mayLoseAccessToProducts)}</div>
                </StudentUnassign>)
            : (
                <ConfirmationMessage
                    handleOnCloseModal={studentsOperationSuccessConfirmation}
                    icon={Tick}
                    title={intl.formatMessage(messages.studentsUnassignedFooter, { s: noOfSelectedStudents > 1 ? 's' : '' })} />);
        break;

    case 'deleteUser':
        confirmation = isUserOperationModalOpen
            ? (
                <UserDelete
                    handleOnCancel={handleOnCloseModal}
                    handleOnOk={handleOnDeleteStudent}
                    heading={intl.formatMessage(messages.deleteConfirmation)}
                    icon={Warning}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.deleteStudents)} />)
            : handleOnDeleteConfirmation();
        break;

    case 'bulkPasswordChange':
        confirmation = isUserOperationModalOpen
            ? (
                <BulkPasswordChange
                    bulkPasswordValue={bulkPasswordValue}
                    handleOnCancel={handleOnCloseModal}
                    handleOnChange={handleOnChangeBulkPasswordSetValue}
                    handleOnOk={handleOnBulkPasswordChangeConfirm}
                    isLoading={isLoading}
                    title={intl.formatMessage(messages.bulkPasswordChange)} />)
            : (
                <ConfirmationMessage
                    handleOnCloseModal={studentsOperationSuccessConfirmation}
                    icon={Tick}
                    title={intl.formatMessage(messages.bulkPasswordChangeSucess)} />);
        break;

    default:
        break;
    }

    return (
        <div className={css.studentFooterComponent}>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.bulkPasswordChange}
                    disabled={noOfSelectedStudents < 2}
                    handleOnClick={handleOnStudentBulkPasswordChange}
                    label={intl.formatMessage(messages.bulkPasswordChange)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.deleteStudents}
                    disabled={noOfSelectedStudents === 0}
                    handleOnClick={handleOnStudentDeleteConfirmation}
                    label={intl.formatMessage(messages.deleteStudents)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.downloadSignInCards}
                    disabled={noOfSelectedStudents === 0}
                    handleOnClick={downloadStudentsSignInCards}
                    label={intl.formatMessage(messages.downloadSignInCards)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.unassign}
                    disabled={noOfSelectedStudents === 0}
                    handleOnClick={handleOnStudentUnassign}
                    label={intl.formatMessage(messages.unassign)}
                    variant={DARK}
                    visible />
            </div>
            <Modal show={showModal}>
                {confirmation}
            </Modal>
        </div>
    );
};

StudentFooter.propTypes = {
    noOfSelectedStudents: PropTypes.number,
    handleOnStudentUnassign: PropTypes.func,
    handleOnDownloadSignInCards: PropTypes.func,
    studentsOperationSuccessConfirmation: PropTypes.func,
    handleOnCloseModal: PropTypes.func,
    handleOnUnassignConfirm: PropTypes.func,
    showModal: PropTypes.bool,
    isUserOperationModalOpen: PropTypes.bool,
    handleOnStudentBulkPasswordChange: PropTypes.func,
    handleOnBulkPasswordChangeConfirm: PropTypes.func,
    handleOnChangeBulkPasswordSetValue: PropTypes.func,
    bulkPasswordValue: PropTypes.string,
    isLoading: PropTypes.bool,
    isSignInCardDownloaded: PropTypes.bool,
    handleOnStudentDeleteConfirmation: PropTypes.func,
    intl: intlShape.isRequired,
    handleOnDeleteStudent: PropTypes.func,
    operationType: PropTypes.string,
    handleOnDeleteConfirmation: PropTypes.func,
    downloadStudentsSignInCards: PropTypes.func
};

export default injectIntl(StudentFooter);



// WEBPACK FOOTER //
// ./app/components/student-footer/index.js